import { isAfter, isBefore, isValid, isFuture, isSameDay as isSameDayFNS } from 'date-fns'
import { minDate, maxDate } from './constants'

/**
 * Check if is valid date
 */
function isValidDate(date?: Date) {
  if (!date) return false
  return isValid(date) && isAfter(date, minDate) && isBefore(date, maxDate)
}

/**
 * Check if dates are in same day
 */
function isSameDay(date: string | Date | null | undefined, compareDate: string | Date | null | undefined) {
  if (!date || !compareDate) return false
  return isSameDayFNS(new Date(date), new Date(compareDate))
}

/**
 * Check if date is on future
 */
function todayOrFuture(date: string | Date | null | undefined) {
  if (!date) return false
  return isSameDay(date, new Date()) || isFuture(new Date(date))
}

export { isValidDate, todayOrFuture, isSameDay }
